// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer {
    /* keep footer content styling, but make the section container control the background
       so we can make the entire PageSection black for the contact area */
    background-color: transparent;
    color: white;
     text-align: center;
     /* keep a small bottom padding so absolutely-positioned copyright
         can sit near the section edge without overlapping content */
     padding: 10px 0 4px 0;
    width: 100%;
    z-index: 1;
    position: relative; /* anchor for absolutely-positioned copyright at section edge */
}

.Footer-inner {
    max-width: 1100px;
    margin: 0 auto;
    padding: 28px 24px;
}

.Footer-heading {
    color: #ffffff;
    text-align: center;
    margin: 0 0 32px 0;
    font-size: 2.5rem; /* increased for prominence */
    font-weight: 700;
    letter-spacing: 0.02em;
}

.Footer-links {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
}

.Footer-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: rgba(255,255,255,0.75);
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 0.06em;
    line-height: 1;
    transition: color 180ms ease, opacity 180ms ease, transform 200ms ease, padding 200ms ease;
    padding: 6px 10px;
    border-radius: 6px;
}

.Footer-link-logo {
    display: none; /* hide external image icons to mimic union.co's text-only footer */
}

.Footer-link-label {
    display: inline-block; /* visible label like union.co */
    transform: scale(1);
    transition: transform 200ms ease, letter-spacing 200ms ease, font-weight 200ms ease;
}

.Footer-link:hover,
.Footer-link:focus {
    color: rgba(255,255,255,0.95);
    opacity: 1;
}

.Footer-link:hover {
    transform: translateY(-3px);
    padding-left: 18px;
    padding-right: 18px;
}

.Footer-link:hover .Footer-link-label {
    transform: scale(1.18);
    letter-spacing: 0.09em;
    font-weight: 700;
}

.Footer-copyright { margin: 0; font-size: 0.9rem; color: rgba(255,255,255,0.85);
    /* place copyright at the very bottom-right edge of the footer section on wide screens */
    position: absolute;
    right: -10px; /* small inset from the very edge */
    bottom: -20px; /* moved lower (closer to the edge) */
    text-align: right;
}

@media (max-width: 640px) {
    /* Stack/center on small screens so it doesn't overlap other content */
    .Footer-copyright {
        position: static;
        margin-top: 12px;
        text-align: center;
    }
}

.Footer-absolute {
    position: absolute;
    bottom: 0;
}

/* Contact button (styled to look like the heading) */
.Footer-contact-button {
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    padding: 0;
}
.Footer-contact-button:focus {
    outline: 3px solid rgba(255,255,255,0.12);
    outline-offset: 6px;
}

/* Hover/interaction: subtle lift, scale and highlight */
.Footer-contact-button {
    transition: transform 220ms cubic-bezier(.2,.9,.2,1), color 180ms ease, text-shadow 180ms ease;
    transform-origin: center center;
}
.Footer-contact-button:hover,
.Footer-contact-button:focus,
.Footer-contact-button:focus-visible {
    transform: translateY(-6px) scale(1.06);
    color: #ffffff;
    text-shadow: 0 6px 18px rgba(0,0,0,0.45);
}

@media (prefers-reduced-motion: reduce) {
    .Footer-contact-button {
        transition: none;
        transform: none !important;
    }
}

/* Modal overlay and panel */
.ContactModal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 24px;
}
.ContactModal {
    background: #0b1220;
    color: #fff;
    width: 100%;
    max-width: 720px;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(2,6,23,0.6);
    padding: 28px;
    position: relative;
}
.ContactModal-close {
    position: absolute;
    right: 12px;
    top: 12px;
    background: transparent;
    border: none;
    color: rgba(255,255,255,0.85);
    font-size: 20px;
    cursor: pointer;
}
.ContactModal-title { margin: 0 0 12px 0; font-size: 1.25rem; }

/* Form styles */
.ContactForm { display: grid; gap: 12px; }
.ContactLabel { display: block; font-size: 0.9rem; color: rgba(255,255,255,0.9); }
.ContactInput, .ContactTextarea {
    width: 100%;
    margin-top: 6px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.12);
    background: rgba(255,255,255,0.02);
    color: #fff;
    font-size: 0.95rem;
    box-sizing: border-box;
}
.ContactInput:focus, .ContactTextarea:focus {
    outline: none;
    border-color: rgba(255,255,255,0.24);
    box-shadow: 0 6px 18px rgba(0,0,0,0.45);
}
.ContactTextarea { resize: vertical; }

.ContactForm-actions { display: flex; gap: 12px; justify-content: flex-end; margin-top: 6px; }
.ContactBtn { padding: 10px 14px; border-radius: 8px; font-weight: 600; cursor: pointer; border: 1px solid transparent; }
.ContactBtn--primary { background: #1a73e8; color: #fff; border-color: rgba(255,255,255,0.06); }
.ContactBtn--ghost { background: transparent; color: rgba(255,255,255,0.9); border-color: rgba(255,255,255,0.06); }

@media (max-width: 480px) {
    .ContactModal { padding: 18px; }
    .ContactForm-actions { flex-direction: column-reverse; }
    .ContactBtn { width: 100%; }
}

/* Inline contact form wrapper (when form is shown directly in page) */
.Footer-contact-form {
    max-width: 720px;
    margin: 18px auto 26px auto;
    text-align: left;
}

/* Slightly reduce spacing for very small screens */
@media (max-width: 480px) {
    .Footer-contact-form { margin: 12px 12px 18px 12px; }
}`, "",{"version":3,"sources":["webpack://./src/css/Footer.css"],"names":[],"mappings":"AAAA;IACI;yEACqE;IACrE,6BAA6B;IAC7B,YAAY;KACX,kBAAkB;KAClB;oEAC+D;KAC/D,qBAAqB;IACtB,WAAW;IACX,UAAU;IACV,kBAAkB,EAAE,+DAA+D;AACvF;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB,EAAE,6BAA6B;IAChD,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,0FAA0F;IAC1F,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa,EAAE,mEAAmE;AACtF;;AAEA;IACI,qBAAqB,EAAE,gCAAgC;IACvD,mBAAmB;IACnB,mFAAmF;AACvF;;AAEA;;IAEI,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,oBAAoB,SAAS,EAAE,iBAAiB,EAAE,6BAA6B;IAC3E,wFAAwF;IACxF,kBAAkB;IAClB,YAAY,EAAE,mCAAmC;IACjD,aAAa,EAAE,qCAAqC;IACpD,iBAAiB;AACrB;;AAEA;IACI,sEAAsE;IACtE;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA,qDAAqD;AACrD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;AACA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI,8FAA8F;IAC9F,+BAA+B;AACnC;AACA;;;IAGI,uCAAuC;IACvC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;AACJ;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,eAAe;AACnB;AACA,sBAAsB,kBAAkB,EAAE,kBAAkB,EAAE;;AAE9D,gBAAgB;AAChB,eAAe,aAAa,EAAE,SAAS,EAAE;AACzC,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AACjF;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,uCAAuC;AAC3C;AACA,mBAAmB,gBAAgB,EAAE;;AAErC,uBAAuB,aAAa,EAAE,SAAS,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAC7F,cAAc,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,6BAA6B,EAAE;AACxH,uBAAuB,mBAAmB,EAAE,WAAW,EAAE,oCAAoC,EAAE;AAC/F,qBAAqB,uBAAuB,EAAE,4BAA4B,EAAE,oCAAoC,EAAE;;AAElH;IACI,gBAAgB,aAAa,EAAE;IAC/B,uBAAuB,8BAA8B,EAAE;IACvD,cAAc,WAAW,EAAE;AAC/B;;AAEA,sEAAsE;AACtE;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,uBAAuB,2BAA2B,EAAE;AACxD","sourcesContent":[".Footer {\n    /* keep footer content styling, but make the section container control the background\n       so we can make the entire PageSection black for the contact area */\n    background-color: transparent;\n    color: white;\n     text-align: center;\n     /* keep a small bottom padding so absolutely-positioned copyright\n         can sit near the section edge without overlapping content */\n     padding: 10px 0 4px 0;\n    width: 100%;\n    z-index: 1;\n    position: relative; /* anchor for absolutely-positioned copyright at section edge */\n}\n\n.Footer-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 28px 24px;\n}\n\n.Footer-heading {\n    color: #ffffff;\n    text-align: center;\n    margin: 0 0 32px 0;\n    font-size: 2.5rem; /* increased for prominence */\n    font-weight: 700;\n    letter-spacing: 0.02em;\n}\n\n.Footer-links {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.Footer-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: rgba(255,255,255,0.75);\n    text-decoration: none;\n    text-transform: uppercase;\n    font-size: 0.85rem;\n    letter-spacing: 0.06em;\n    line-height: 1;\n    transition: color 180ms ease, opacity 180ms ease, transform 200ms ease, padding 200ms ease;\n    padding: 6px 10px;\n    border-radius: 6px;\n}\n\n.Footer-link-logo {\n    display: none; /* hide external image icons to mimic union.co's text-only footer */\n}\n\n.Footer-link-label {\n    display: inline-block; /* visible label like union.co */\n    transform: scale(1);\n    transition: transform 200ms ease, letter-spacing 200ms ease, font-weight 200ms ease;\n}\n\n.Footer-link:hover,\n.Footer-link:focus {\n    color: rgba(255,255,255,0.95);\n    opacity: 1;\n}\n\n.Footer-link:hover {\n    transform: translateY(-3px);\n    padding-left: 18px;\n    padding-right: 18px;\n}\n\n.Footer-link:hover .Footer-link-label {\n    transform: scale(1.18);\n    letter-spacing: 0.09em;\n    font-weight: 700;\n}\n\n.Footer-copyright { margin: 0; font-size: 0.9rem; color: rgba(255,255,255,0.85);\n    /* place copyright at the very bottom-right edge of the footer section on wide screens */\n    position: absolute;\n    right: -10px; /* small inset from the very edge */\n    bottom: -20px; /* moved lower (closer to the edge) */\n    text-align: right;\n}\n\n@media (max-width: 640px) {\n    /* Stack/center on small screens so it doesn't overlap other content */\n    .Footer-copyright {\n        position: static;\n        margin-top: 12px;\n        text-align: center;\n    }\n}\n\n.Footer-absolute {\n    position: absolute;\n    bottom: 0;\n}\n\n/* Contact button (styled to look like the heading) */\n.Footer-contact-button {\n    background: transparent;\n    border: none;\n    color: #ffffff;\n    font-size: 2.5rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    cursor: pointer;\n    padding: 0;\n}\n.Footer-contact-button:focus {\n    outline: 3px solid rgba(255,255,255,0.12);\n    outline-offset: 6px;\n}\n\n/* Hover/interaction: subtle lift, scale and highlight */\n.Footer-contact-button {\n    transition: transform 220ms cubic-bezier(.2,.9,.2,1), color 180ms ease, text-shadow 180ms ease;\n    transform-origin: center center;\n}\n.Footer-contact-button:hover,\n.Footer-contact-button:focus,\n.Footer-contact-button:focus-visible {\n    transform: translateY(-6px) scale(1.06);\n    color: #ffffff;\n    text-shadow: 0 6px 18px rgba(0,0,0,0.45);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .Footer-contact-button {\n        transition: none;\n        transform: none !important;\n    }\n}\n\n/* Modal overlay and panel */\n.ContactModal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1200;\n    padding: 24px;\n}\n.ContactModal {\n    background: #0b1220;\n    color: #fff;\n    width: 100%;\n    max-width: 720px;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(2,6,23,0.6);\n    padding: 28px;\n    position: relative;\n}\n.ContactModal-close {\n    position: absolute;\n    right: 12px;\n    top: 12px;\n    background: transparent;\n    border: none;\n    color: rgba(255,255,255,0.85);\n    font-size: 20px;\n    cursor: pointer;\n}\n.ContactModal-title { margin: 0 0 12px 0; font-size: 1.25rem; }\n\n/* Form styles */\n.ContactForm { display: grid; gap: 12px; }\n.ContactLabel { display: block; font-size: 0.9rem; color: rgba(255,255,255,0.9); }\n.ContactInput, .ContactTextarea {\n    width: 100%;\n    margin-top: 6px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(255,255,255,0.12);\n    background: rgba(255,255,255,0.02);\n    color: #fff;\n    font-size: 0.95rem;\n    box-sizing: border-box;\n}\n.ContactInput:focus, .ContactTextarea:focus {\n    outline: none;\n    border-color: rgba(255,255,255,0.24);\n    box-shadow: 0 6px 18px rgba(0,0,0,0.45);\n}\n.ContactTextarea { resize: vertical; }\n\n.ContactForm-actions { display: flex; gap: 12px; justify-content: flex-end; margin-top: 6px; }\n.ContactBtn { padding: 10px 14px; border-radius: 8px; font-weight: 600; cursor: pointer; border: 1px solid transparent; }\n.ContactBtn--primary { background: #1a73e8; color: #fff; border-color: rgba(255,255,255,0.06); }\n.ContactBtn--ghost { background: transparent; color: rgba(255,255,255,0.9); border-color: rgba(255,255,255,0.06); }\n\n@media (max-width: 480px) {\n    .ContactModal { padding: 18px; }\n    .ContactForm-actions { flex-direction: column-reverse; }\n    .ContactBtn { width: 100%; }\n}\n\n/* Inline contact form wrapper (when form is shown directly in page) */\n.Footer-contact-form {\n    max-width: 720px;\n    margin: 18px auto 26px auto;\n    text-align: left;\n}\n\n/* Slightly reduce spacing for very small screens */\n@media (max-width: 480px) {\n    .Footer-contact-form { margin: 12px 12px 18px 12px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
